import {
  FormControl,
  Box,
  Button,
  WrapItem,
  CircularProgress,
} from "@chakra-ui/react";
import { Flex } from "@chakra-ui/react";
import { Image, Heading, Stack } from "@chakra-ui/react";
import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import TextInput from "../../theme/components/input/text-input";
import { ErrorMessage, Form, Formik } from "formik";
import * as yup from "yup";
import { colors } from "../../theme/styles/colors";
import { useDispatch } from "react-redux";
import api from "../../core/api";
import { SuccessAlert } from "../../core/utils/common-sweet-alert";
import SCHEMA_VALIDATOR from "../../core/utils/schema-validator";
import { useEffect } from "react";

function ForgetPassword() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [initialState, setInitialState] = useState({
    username: "",
  });

  const validationSchema = yup.object({
    username: SCHEMA_VALIDATOR.STRING_VALIDATOR,
  });
  useEffect(() => {
    document.title = "Forget Password | Digital Filing";
  }, []);

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={initialState}
      onSubmit={(values) => {
        setIsLoading(true);
        api
          .get(`/Account/forgot-password/?username=${values.username}`)
          .then((res) => {
            setIsLoading(false);
            if (res.data.statusCode === 202) {
              navigate("/");
              SuccessAlert(res.data.message);
            }
          })
          .catch((err) => {
            setIsLoading(false);
          });
      }}
    >
      {({ handleSubmit, handleChange, values, errors }) => (
        <Form
          noValidate={true}
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <Flex dir="row">
            <Box
              display={{ base: "none", sm: "none", md: "block", lg: "block" }}
              border={1}
              borderColor={"green"}
              borderWidth={1}
              h={"100vh"}
              w={"50%"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Box className="login">
                <Box className="left-content"></Box>
              </Box>
            </Box>
            <Box
              border={1}
              padding={{ base: "30px", sm: "30px", md: "30px", lg: "30px" }}
              borderWidth={1}
              h={"100vh"}
              borderColor={"#F0AC00"}
              w={{ base: "100%", sm: "100%", md: "50%", lg: "50%" }}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Box w={{ base: "100%", sm: "100%", md: "50%", lg: "50%" }}>
                <Box
                  position={"absolute"}
                  right={"0px"}
                  top={"10px"}
                  fontSize={"14px"}
                ></Box>
                {/* <Flex
                  justifyContent={"center"}
                  w={"100px"}
                  margin={"0px auto 20px"}
                >
                  <Image src="./images/HSLogo.png" />
                </Flex> */}

                <Stack spacing={6} marginBottom={"30px"}>
                  <Heading variant={"h2"}>Forgot Password</Heading>
                  <Heading variant={"h5"}>
                    Enter your username to proceed
                  </Heading>
                </Stack>
                <FormControl gap="3">
                  <TextInput
                    type="text"
                    isRequired={true}
                    name="username"
                    value={values.username}
                    label={{
                      text: "Username",
                      colors: errors.username ? "red !important" : "",
                      variant: errors.username ? "errored" : "",
                    }}
                    onChange={(e) => handleChange(e)}
                    placeholder={""}
                    variant={errors.username ? "errored" : "flushed"}
                    isReadOnly={isLoading}
                    paddingLeft={"0px"}
                  />
                </FormControl>
                <Box>
                  <WrapItem gap={"10px"}>
                    <Button
                      variant={"warning"}
                      width={"100%"}
                      marginTop={"20px"}
                      type="button"
                      onClick={() => navigate("/")}
                    >
                      Back
                    </Button>
                    <Button
                      variant={"primary"}
                      width={"100%"}
                      marginTop={"20px"}
                      type="submit"
                    >
                      {isLoading ? (
                        <CircularProgress
                          isIndeterminate
                          size="24px"
                          color={colors.white}
                        />
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  </WrapItem>
                </Box>
              </Box>
            </Box>
          </Flex>
        </Form>
      )}
    </Formik>
  );
}

export default ForgetPassword;
